// +-------------------------------------------------------------
// | Created by WebStorm.
// +-------------------------------------------------------------
// | User: msmile
// +-------------------------------------------------------------
// | Date: 2024/2/2
// +-------------------------------------------------------------
// |Time: 14:29
// +-------------------------------------------------------------
import {createRouter, createWebHistory,} from 'vue-router'
import routes from './module/index'
import {useUserStore} from "@/store/module/user";
import {getAuthorizeLink} from "@/utils/common";
import {wxLogin} from "@/api";


const router = createRouter({
    history: createWebHistory(),
    routes
})
//渲染一个路由的过程中，尝试解析一个异步组件时发生的错误
router.onError((error) => {
    const pattern = /Loading chunk (\d)+ failed/g;
    const isChunkLoadFailed = error.message.match(pattern);
    const targetPath = router.history.pending.fullPath;
    if (isChunkLoadFailed) {
        router.replace(targetPath);
    }
});
/**
 * Router 前置拦截
 *
 * 1.验证 token 存在, 并且有效, 否则 -> login.vue
 * 2.验证 permission 存在, 否则 -> 403.vue
 * 3.验证 router 是否存在, 否则 -> 404.vue
 *
 * @param to 目标
 * @param from 来至
 */
let userStore = null;
router.beforeEach((to, from, next) => {
    document.title = `${to.meta.title} | 久氪APP`;
    if (userStore === null) {
        userStore = useUserStore()
    }
    if (!to?.meta?.noAuth && !userStore.token) {
        if(to?.query?.code){
            wxLogin(to.query.code).then(({data})=>{
                userStore.token = data.token;
                next({path: to.path || "/"})
            }).catch(()=>{
               next({path: to.path || "/"})
            })
        }else{
            window.location.href = getAuthorizeLink()
        }
    }else {
        next();
    }
})
export default router
